/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('gallery', {
    templateUrl: 'app/shared/gallery/Gallery.html',
    controller: Gallery,
    bindings: {
      images: '<',
      imagesMini: '<'
    }
  });

function Gallery() {}

Gallery.prototype = {
  $onInit: function () {
    this.images = angular.isArray(this.images) ? this.images : [];
    this.imagesMini = angular.isArray(this.imagesMini) ? this.imagesMini : [];
  }
};
